window.addEventListener('DOMContentLoaded', () => {
    if (phoneActive) {
        readaptToPhone();
    }

    checkSectionsOverflow();
    scrollInsideElement('.selectedMain', '.sections-gallery', 30, 'x');
    window.addEventListener("resize", checkSectionsOverflow);
});

function updateSectionProgressBar() {
    var line = document.getElementById('scroll-status-line').getElementsByTagName('span')[0];
    let totalHeight = document.getElementsByTagName('html')[0].offsetHeight - document.getElementsByTagName('html')[0].clientHeight;
    let scrollPosition = document.getElementsByTagName('html')[0].scrollTop;
    let difference = ((scrollPosition / totalHeight) * 100);
    if (line) {
        line.style.width = difference + '%'
    }
}
function readaptToPhone() {
    document.getElementById('section-search-filter').remove();
    document.getElementById('catalog-name-logo').remove();
    document.getElementsByClassName('product-div')[0].style.flexWrap = 'wrap';
    document.getElementsByClassName('right-side')[0].style.marginLeft = '0px';
    $('.my-account').remove();
    $('.orders').remove();
}
function checkSectionsOverflow() {
    var el = document.getElementById('sections-gallery');
    var is = isOverflownX(el);
    var scrollBtns = document.getElementsByClassName('scrollXbutton');
    if (is) {
        for (var i = 0; i < scrollBtns.length; i++) {
            scrollBtns[i].style.display = "block";
        }
    }
    else {
        for (var i = 0; i < scrollBtns.length; i++) {
            scrollBtns[i].style.display = "none";
        }
    }
    function isOverflownX(element) {
        return element.scrollWidth > element.clientWidth;
    }
}
function removefocusSectionSearch() {
    var sectionDropdown = document.getElementById('section-search-filter');
    sectionDropdown.style.border = "none";
}
function focusSectionSearch() {
    var sectionDropdown = document.getElementById('section-search-filter');
    sectionDropdown.style.border = "2px solid red";
}
function setPlaceHolder(el) {
    document.getElementById('searchInput').placeholder = `Buscar en ${el.options[el.selectedIndex].text}...`;
}